"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Dropdown = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const ui_common_components_1 = require("@desygner/ui-common-components");
const ui_common_translation_1 = require("@desygner/ui-common-translation");
const Button_1 = require("../Button");
exports.Dropdown = (0, react_1.memo)(function Dropdown({ items, icon, title, variant, placement = 'bottom', onUpdate, }) {
    const { t } = (0, ui_common_translation_1.useTranslation)();
    const handleItemClick = (0, react_1.useCallback)((item) => {
        onUpdate({
            action: item.action,
            data: item.data,
        });
    }, [onUpdate]);
    const mappedElement = items === null || items === void 0 ? void 0 : items.map((item) => {
        return {
            label: t(item.titleKey),
            icon: item.icon,
            value: t(item.titleKey),
            extra: item.shortcut && (0, jsx_runtime_1.jsx)(ui_common_components_1.Shortcut, { value: item.shortcut }),
            onClick: (value, event) => handleItemClick(item),
        };
    });
    return ((0, jsx_runtime_1.jsx)(ui_common_components_1.DropdownNext, { options: mappedElement || [], trigger: "click", placement: placement, onClick: onUpdate, children: (0, jsx_runtime_1.jsx)(Button_1.Button, { icon: icon, title: title, variant: variant, onClick: (event) => event && event.preventDefault() }) }));
});
//# sourceMappingURL=Dropdown.js.map